import { useIntl } from 'react-intl'

import type { UseLoadScriptOptions } from '@react-google-maps/api/dist/useJsApiLoader'

export function useGoogleMapConfiguration(): UseLoadScriptOptions {
  const intl = useIntl()
  return {
    language: intl.locale,
    region: 'ca',
    mapIds: [import.meta.env.VITE_GOOGLE_MAP_ID],
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  }
}
